import React, { useState } from "react";
import {
  SubmitButton,
  TextComponent,
  TextHeader,
} from "../../../../components";
import styles from "./RequestedRsvp.module.css";
import { BiSearchAlt2, BiCheck } from "react-icons/bi";
import { List, RadioChangeEvent } from "antd";
import Modal from "../../../../components/modal/Modal";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const RequestedRsvp = () => {
  const RSVP = useSelector((state) => state.EventPlanningReducer.RSVP);

  console.log(RSVP);
  // const [Users, setUsers] = useState([]);
  // const [isSelected, setIsSelected] = useState(false);
  const navigate = useNavigate();
  // const options = [
  //   { id: 1, label: "Frances Swann", value: "Frances Swann" },
  //   { id: 2, label: "Kenneth Allen", value: "Kenneth Allen" },
  //   { id: 3, label: "Daniel Hamilton", value: "Daniel Hamilton" },
  //   { id: 4, label: "Paula Mora", value: "Paula Mora" },
  //   { id: 5, label: "Rodger Struck", value: "Rodger Struck" },
  //   { id: 6, label: "Iva Ryan", value: "Iva Ryan" },
  //   { id: 7, label: "Joshua Jones", value: "Joshua Jones" },
  //   { id: 8, label: "Joshua Jones", value: "Joshua Jones" },
  // ];
  return (
    <div>
      <TextHeader
        text={"9. Send to your guests"}
        containerClass={styles.textContainer}
      />
      {/* <div className={styles.mainInput}>
        <BiSearchAlt2 className={styles.icon} size={20} />
        <input className={styles.input1} placeholder="Search for guests" />
      </div>
      <div className={styles.containerHeader}>
        <div className={styles.listItem}>
          <div
            onClick={() => {
              setUsers(options);

            }}
            className={
              styles.radioButton
            }
          >
          </div>
          <h1 className={styles.radioText}>Select All</h1>
        </div>
      </div> */}

      <List
        className={styles.list}
        grid={{ xxl: 2, xl: 2, lg: 2, xs: 1, md: 2, column: 2 }}
        itemLayout="horizontal"
        dataSource={RSVP?.seating?.table?.users}
        renderItem={(item, i) => (
          <RenderItems
            item={item}
            i={i}
            // Users={Users}
            // options={options}
            // setUsers={setUsers}
            // setIsSelected={setIsSelected}
            // isSelected={isSelected}
          />
        )}
      />
      <SubmitButton
        btnClass={styles.btnClass}
        title="Next"
        onClick={() =>
          navigate("/events/rsvp/requestedrsvp2", {
            state: { headrTitle: "Request RSVP" },
          })
        }
      />
    </div>
  );
};

const RenderItems = ({
  item
}) => {
  return (
    <div className={styles.listContainer}>
      <div
        // onClick={() => {
        //   let arr = [...Users];
        //   const find = arr?.find((e) => e?.id == item?.id);
        //   if (!find) {
        //     arr?.push({
        //       ...item,
        //       select: true
        //     });
        //     setUsers(arr);
        //     setIsSelected(true);
        //   } else {
        //     const filter = arr?.filter((e) => e?.id != item?.id);
        //     setUsers(filter);
        //     setIsSelected(false);
        //   }
        // }}
        className={styles.slectedRadioButton }
      >
        <BiCheck className={styles.radioIcon} /> 
      </div>
      <h1 className={styles.radioText}>{item?.name}</h1>
    </div>
  );
};

export default RequestedRsvp;
